import { useQuery, gql, type QueryResult } from '@apollo/react-hooks';
import { getAssetType } from '#/graphql/queries';
import type { GetAssetTypeQuery } from '#/graphql/types';

export const GET_ASSET_TYPE = gql(getAssetType);

const useAssetTypeQuery = (id?: string) => {
  const query: QueryResult<GetAssetTypeQuery> = useQuery(GET_ASSET_TYPE, {
    variables: { id },
    fetchPolicy: 'cache-and-network',
  });

  return query;
};

export default useAssetTypeQuery;
